import React from 'react';
import Money from '../puppet/Money';
var InvoiceExtraFields = function (_a) {
    var form = _a.form, fields = _a.fields;
    return (React.createElement("div", { className: 'invoice-extra-details' }, fields.map(function (value, index) { return (React.createElement("div", { key: index, className: 'dis-f jc-sb' },
        React.createElement("span", { className: "title" }, value.label || '-'),
        value.type === 'money' && React.createElement("span", { className: "content" },
            React.createElement(Money, { value: value.value })),
        value.type !== 'money' && React.createElement("span", { className: "content" }, value.value))); })));
};
export default InvoiceExtraFields;
